module.exports = __webpack_public_path__ + "static/media/doctor-sm.eb24d439.png";